function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8744 5.14645C17.6791 4.95118 17.3625 4.95118 17.1673 5.14645L11.8639 10.4498L6.56066 5.14655C6.3654 4.95129 6.04882 4.95129 5.85355 5.14655L5.14645 5.85366C4.95119 6.04892 4.95119 6.3655 5.14645 6.56077L10.4497 11.864L5.14645 17.1673C4.95118 17.3625 4.95118 17.6791 5.14645 17.8744L5.85355 18.5815C6.04882 18.7767 6.3654 18.7767 6.56066 18.5815L11.8639 13.2782L17.1673 18.5816C17.3625 18.7768 17.6791 18.7768 17.8744 18.5816L18.5815 17.8745C18.7767 17.6792 18.7767 17.3626 18.5815 17.1674L13.2781 11.864L18.5815 6.56066C18.7767 6.3654 18.7767 6.04882 18.5815 5.85355L17.8744 5.14645Z",
  fill: "#061220"
});

function SvgClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.be0bc551.svg";
export { ForwardRef as ReactComponent };